import React, { useEffect, useState } from "react";
import titleIco from "../../images/profile_ico.svg";
import FoujiImg from "../../images/fouji associates.jpeg";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import profileImg from "../../images/profile.png";
import {
  Box,
  Button,
  Grid,
  Stack,
  styled,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import Address from "./Address";
import DialogComponent from "../reusableComponents/Dialog";
import UserRepository from "../../Repository/UserRepository";
import UpdatePassword from "./UpdatePassword";
import UpdateImg from "./UpdateImg";
import DeleteDialog from "../reusableComponents/DeleteDialog";

const Banner = styled("div")({
  position: "relative",
  background: "#4eaf51",
  borderRadius: "4px",
  textAlign: "center",
  color: "white",
  padding: "20px 20px",
  margin: "20px 0px",
  height: "130px",
});
const imgStyle = {
  position: "absolute",
  right: 0,
  top: 0,
  bottom: 0,
  margin: "auto",
  width: "120px",
  height: "120px",
};
const profileImgStyle = {
  maxWidth: "170px",
  maxHeight: "140px",
  margin: "auto",
  border: "5px solid white",
  backgroundColor: "white",
  borderRadius: "10px",
  boxShadow: "0px 0px 12px #bebebe",
  zIndex: 1,
};
const ProfileSection = styled("div")({
  marginTop: "-70px",
  display: "flex",
  justifyContent: "space-around",
});
const ProfileIcon = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#fff",
  boxShadow: "0px 4px 16px rgb(0 0 0 / 16%)",
  borderRadius: "4px",
  cursor: "pointer",
  padding: "5px",
});
const ProfileData = styled("div")({
  borderRadius: "6px",
  background: "#ffffff",
  margin: "30px 0",
});
const GreyBox = styled(Stack)({
  fontWeight: "normal",
  background: "#f3f3f3",
  borderBottom: "1px solid #999999",
  borderRadius: "6px",
  padding: "12px 50px",
  width: "100%",
});
const GreySelect = styled(Select)({
  fontWeight: "normal",
  background: "#f3f3f3",
  borderBottom: "1px solid #999999",
  borderRadius: "6px",
  padding: "12px 50px",
  width: "100%",
});

const GreyMenuItem = styled(MenuItem)({
  background: "#f3f3f3",
  fontWeight: "normal",
  "&:hover": {
    background: "#e0e0e0",
  },
});
function CompanyInfo() {
  const companyCode = localStorage.getItem("companyCode");
  const [state, setState] = useState({
    loading: false,
    addressModal: false,
    passwordModal: false,
    imgModal: false,
    deleteModal: false,
    user: "",
  });

  useEffect(() => {
    getUser();
  }, []);
  const toggle = (name) => {
    setState((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const getUser = async () => {
    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await UserRepository.usersModel({
      request: {
        method: "getUser",
        data: {
          _id: localStorage.getItem("token"),
        },
      },
    });
    let User = data.response.data.user;
    localStorage.removeItem("phone");
    localStorage.removeItem("p1");
    localStorage.removeItem("p2");
    setState((prev) => ({ ...prev, user: User, loading: false }));
    if (User?.imgURL) {
      localStorage.setItem("companyImg", User?.imgURL);
    }
    if (User?.address) {
      localStorage.setItem(
        "address",
        User.address.street + " " + User.address.city
      );
      if (User.address?.selectedPhone == "phoneTwo") {
        localStorage.setItem("phone", User.address.phoneTwo);
      } else if (User.address?.selectedPhone == "phoneOne") {
        localStorage.setItem("phone", User.address.phoneOne);
      } else if (User?.address?.selectedPhone == "bothNumbers") {
        localStorage.setItem("p1", User?.address?.phoneOne);
        localStorage.setItem("p2", User?.address?.phoneTwo);
      } else {
        localStorage.setItem("phone", User?.phone);
      }
    }
  };

  const deleteProfileImage = async () => {
    let copy = JSON.parse(JSON.stringify(state.user));
    delete copy.imgURL;
    delete copy.base_url;
    let { data } = await UserRepository.usersModel({
      request: {
        method: "updateUser",
        data: {
          _id: state.user._id,
          user: {
            ...copy,
          },
        },
      },
    });
    getUser();
  };

  const updateAddress = (e) => {
    setState((prev) => ({ ...prev, user: { ...prev.user, address: e } }));
  };

  return (
    <div>
      {companyCode == 4416 && (
        <Box
          sx={{
            mt: { md: "5px", xs: "40px" },
            position: "relative",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            style={{ marginTop: "20px" }}
            width="60%"
            height="200px"
            src={FoujiImg}
            // className="imgStyle"
          />
        </Box>
      )}
      {companyCode != 4416 && (
        <Banner sx={{ mt: { md: "5px", xs: "40px" } }}>
          <Typography variant="body1" sx={{ mb: "20px" }}>
            Welcome to your company profile
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: { lg: "2.125rem", md: "1rem", xs: "14px" } }}
          >
            {state.user?.company_name || ""}
          </Typography>
          <img src={titleIco} className="imgStyle" />
        </Banner>
      )}
      <ProfileSection>
        <Box sx={{ zIndex: 5 }}>
          <img
            className="profile-img-style"
            src={state?.user?.imgURL || profileImg}
          />

          <Stack direction="row" justifyContent="space-between">
            <ProfileIcon
              sx={{ color: "#4EAF51" }}
              onClick={() => toggle("imgModal")}
            >
              <CameraAltIcon />
            </ProfileIcon>
            <ProfileIcon
              sx={{ color: "red" }}
              onClick={() => toggle("deleteModal")}
            >
              <DeleteTwoToneIcon />
            </ProfileIcon>
          </Stack>
        </Box>
        <h2 className="profile-name ft600 dark-grey">
          <span className="green">CEO :</span>{" "}
          <Typography sx={{ fontSize: { md: "16px", xs: "14px" } }}>
            {state.user?.name}
          </Typography>
        </h2>

        <h2 className="profile-name ft600 dark-grey">
          <span className="green">Address :</span>{" "}
          <Typography sx={{ fontSize: { md: "16px", xs: "14px" } }}>
            {state.user?.address?.street},{state.user?.address?.city}
          </Typography>
        </h2>
      </ProfileSection>

      <ProfileData sx={{ padding: { md: "33px 70px", xs: "16px 16px" } }}>
        <Grid container spacing={2}>
          {/* <Grid item lg={4} md={4} sm={12} xs={12}>
            <Typography
              variant="h6"
              sx={{
                color: "#4EAF51",
                fontSize: { md: "1.25rem", xs: "14px" },
              }}
            >
              Sale Label:
            </Typography>
          </Grid>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <GreySelect defaultValue="" sx={{padding:"0px"}}>
              <GreyMenuItem value="ctn">Ctn</GreyMenuItem>
              <GreyMenuItem value="box">Box</GreyMenuItem>
            </GreySelect>
          </Grid> */}
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Typography
              variant="h6"
              sx={{
                color: "#4EAF51",
                fontSize: { md: "1.25rem", xs: "14px" },
              }}
            >
              Company Code:
            </Typography>
          </Grid>
          <Grid item lg={7} md={6} sm={9} xs={8.5}>
            <GreyBox alignItems="center" justifyContent="center">
              {companyCode}
            </GreyBox>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Typography
              variant="h6"
              sx={{
                color: "#4EAF51",
                fontSize: { md: "1.25rem", xs: "14px" },
              }}
            >
              Email:
            </Typography>
          </Grid>
          <Grid item lg={7} md={6} sm={9} xs={8.5}>
            <GreyBox alignItems="center" justifyContent="center">
              {state.user?.email}
            </GreyBox>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Typography
              variant="h6"
              sx={{
                color: "#4EAF51",
                fontSize: { md: "1.25rem", xs: "14px" },
              }}
            >
              Terms and Conditions:
            </Typography>
          </Grid>
          <Grid item lg={7} md={6} sm={9} xs={8.5}>
            <GreyBox alignItems="center" justifyContent="center">
              {state.user?.address?.terms || " "}
            </GreyBox>
            <Button
              variant="contained"
              sx={{ mt: "5px" }}
              onClick={() => toggle("addressModal")}
            >
              <BorderColorIcon
                style={{
                  marginRight: "9px",
                  fontSize: { md: "1.25rem", xs: "14px" },
                }}
              />{" "}
              Address and TOS
            </Button>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Typography
              variant="h6"
              sx={{
                color: "#4EAF51",
                fontSize: { md: "1.25rem", xs: "14px" },
              }}
            >
              Current Password:
            </Typography>
          </Grid>
          <Grid item lg={7} md={6} sm={9} xs={8.5}>
            <GreyBox alignItems="center" justifyContent="center">
              **********
            </GreyBox>
            <Button
              variant="contained"
              sx={{ mt: "5px" }}
              onClick={() => toggle("passwordModal")}
            >
              <BorderColorIcon
                style={{ marginRight: "12px" }}
                sx={{ fontSize: { md: "1.25rem", xs: "14px" } }}
              />{" "}
              Edit
            </Button>
          </Grid>
        </Grid>
      </ProfileData>
      <DialogComponent
        title="Address"
        open={state.addressModal}
        onClose={() => toggle("addressModal")}
        dialogContent={
          <Address
            user={state.user}
            onClose={() => toggle("addressModal")}
            onSuccess={updateAddress}
          />
        }
      />
      <DialogComponent
        title="Password"
        open={state.passwordModal}
        onClose={() => toggle("passwordModal")}
        dialogContent={
          <UpdatePassword
            id={state?.user?._id}
            onClose={() => toggle("passwordModal")}
            onSuccess={getUser}
          />
        }
      />
      <DialogComponent
        title="Image"
        open={state.imgModal}
        onClose={() => toggle("imgModal")}
        dialogContent={
          <UpdateImg
            user={state.user}
            onClose={() => toggle("imgModal")}
            onSuccess={getUser}
          />
        }
      />

      <DeleteDialog
        title="Delete Image"
        open={state.deleteModal}
        onClose={() => toggle("deleteModal")}
        onClickYes={deleteProfileImage}
      />
    </div>
  );
}

export default CompanyInfo;
